import React from "react";
import "./styles/footer.css";
import { Link, useNavigate } from "react-router-dom";
import { FiFacebook } from "react-icons/fi";
import { CiYoutube } from "react-icons/ci";
import { PiInstagramLogoThin } from "react-icons/pi";
import { LuMail } from "react-icons/lu";
import { FaLocationDot } from "react-icons/fa6";
import { BiPhoneCall } from "react-icons/bi";
import { TiSocialLinkedin } from "react-icons/ti";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="partition"></div>
      <div className="footer-conatiner">
        <div className=" footer-main">
          <h1 className="footer-heading">Ready to grow?</h1>
          <p className="footer-para">
            Sign up now and start earning with Real Opinion.
          </p>
          <button className="btn-primary" 
          onClick={() => {
            window.open("https://publisher.realopinions.ai/register") 
          }}
          >Get Started</button>
          <div className="footer-links-container">
            <div className="publisher-footer">
              <h4>Page</h4>
              <Link className="footer-links" onClick={()=>window.scrollTo(0,0)} to={"/"} >Publisher</Link>
              <Link className="footer-links" to={"/about"}>About Us</Link>
              <Link className="footer-links" onClick={() => window.open("https://prorewards.gitbook.io/real-opinion")}>Integrate</Link>
              <Link className="footer-links" to={"/contact"}>Contact Us</Link>
              <Link className="footer-links" to={"/privacy"}>Privacy Policy</Link>
              <Link className="footer-links" to={"/terms-condition"}>Terms & Conditions</Link>
            </div>
            <div className="contact-footer">
              <h4>Contact</h4>
              <Link onClick={() => window.open("mailto:Info@realopinions.ai")} className="footer-links">
                <LuMail color="#fff" size={20} />
                Info@realopinions.ai
              </Link>
              <Link className="footer-links">
                <FaLocationDot color="#fff" size={20} />
                Head Office Address - A – 25, 1st Floor, Sector -16, Noida, Uttar Pradesh - 201301
              </Link>
              <Link className="footer-links">
                <BiPhoneCall color="#fff" size={20} />
                +91 7505976833
              </Link>
            </div>
          </div>
          <div className="footer-bottom-line"></div>
          <div className="footer-bottom-social">
            <div className="social-div">
              <h5 className="footer-social-heading">Follow Us</h5>
              <div className="social-icons">
                <div className="footer-social-icon">
                <TiSocialLinkedin style={{
                  cursor:"pointer"
                }} onClick={()=>window.open("https://www.linkedin.com/company/prorewards/")} />
                </div>
                {/* <div className="footer-social-icon">
                  <CiYoutube></CiYoutube>
                </div>
                <div className="footer-social-icon">
                  <PiInstagramLogoThin></PiInstagramLogoThin>
                </div> */}
              </div>
            </div>
            <div className="footer-started">
              <button
                className="btn-primary"
                onClick={() => {
                  window.open("https://publisher.realopinions.ai/login")
                    ;
                }}
              >
                Sign In
              </button>
              <button
                className="btn-primary"
                onClick={() => {
                  navigate("/contact");
                  window.scrollTo(0, 0);
                }}
              >
                Contact Us
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
